import Breadcrumb from '../components/Breadcrumb'
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { OutboundLink } from 'react-ga'
import { initialize } from '../store/pagedata'
import styles from '../styles/InfoPages.module.scss'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

const AboutUs = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(initialize())
  }, [])

  return (
    <>
      <Helmet>
        <meta name='description' content='About Us' />
        <meta name='keywords' content='EDHREC,about,about us' />
        <title>About Us | EDHREC</title>
      </Helmet>

      <Breadcrumb breadcrumb={[{ '/about-us': 'About Us' }]} />
      <h4 className='page-heading'>About Us</h4>
      <Container>
        <div className={styles.infoCardContainer}>
          <Card>
            <Card.Header as='h4'>About EDHREC</Card.Header>
            <Card.Body>
              EDHREC was founded in 2015 as a data-driven Magic: The Gathering
              resource for the{' '}
              <OutboundLink
                eventLabel='https://mtgcommander.net'
                rel='noopener noreferrer'
                target='_blank'
                to='https://mtgcommander.net'
              >
                Commander
              </OutboundLink>{' '}
              format (also known as EDH). We provide data on popular archetypes,
              deck staples, and high synergy combos to help you build your next
              deck. We offer direct feedback in the form of{' '}
              <Link target='_blank' to='/recs'>
                Deck Recommendations
              </Link>
              , and Advanced Filters to help power users hone in on the perfect
              99.
              <br />
              <br />
              We post daily articles on EDHREC and{' '}
              <OutboundLink
                eventLabel='https://commandersherald.com'
                rel='noopener noreferrer'
                target='_blank'
                to='https://commandersherald.com'
              >
                Commander’s Herald,
              </OutboundLink>{' '}
              and are home to the{' '}
              <OutboundLink
                eventLabel='https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g'
                rel='noopener noreferrer'
                target='_blank'
                to='https://www.youtube.com/channel/UCApiDwDpn_JpzRGLZKrdr1g'
              >
                EDHRECast
              </OutboundLink>
              , a weekly podcast dedicated to providing additional context to
              the site's data and card recommendations.
              <br />
              <br />
              Recently the team has expanded its efforts to other games
              including{' '}
              <OutboundLink
                eventLabel='https://raidfeats.gg'
                rel='noopener noreferrer'
                target='_blank'
                to='https://raidfeats.gg'
              >
                World of Warcraft
              </OutboundLink>
              {', and '}
              <OutboundLink
                eventLabel='https://twitter.com/FAB_REC'
                rel='noopener noreferrer'
                target='_blank'
                to='https://twitter.com/FAB_REC'
              >
                Flesh and Blood
              </OutboundLink>
              .
            </Card.Body>
          </Card>
        </div>
        <div className={styles.infoCardContainer}>
          <Card>
            <Card.Header as='h4'>About Our Data Partners</Card.Header>
            <Card.Body>
              EDHREC pulls decklists from:
              <br />
              <ul>
                <li>
                  <OutboundLink
                    eventLabel='https://www.aetherhub.com'
                    target='_blank'
                    to='https://www.aetherhub.com'
                  >
                    AetherHub
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    eventLabel='https://www.archidekt.com'
                    target='_blank'
                    to='https://www.archidekt.com'
                  >
                    Archidekt
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    eventLabel='https://www.deckstats.net/'
                    target='_blank'
                    to='https://www.deckstats.net/'
                  >
                    deckstats.net
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    eventLabel='https://www.moxfield.com/'
                    target='_blank'
                    to='https://www.moxfield.com/'
                  >
                    Moxfield
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    eventLabel='https://www.mtggoldfish.com/'
                    target='_blank'
                    to='https://www.mtggoldfish.com/'
                  >
                    MTGGoldfish
                  </OutboundLink>
                </li>
              </ul>
              <br />
              EDHREC pulls card data from:
              <br />
              <ul>
                <li>
                  <OutboundLink
                    eventLabel='https://www.commanderspellbook.com/'
                    target='_blank'
                    to='https://www.commanderspellbook.com/'
                  >
                    Commander Spellbook
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    eventLabel='https://www.scryfall.com/'
                    target='_blank'
                    to='https://www.scryfall.com/'
                  >
                    Scryfall
                  </OutboundLink>
                </li>
              </ul>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </>
  )
}

export default AboutUs
